<template>
  <el-dialog :title="editOrview ? '编辑信息' : '查看信息'" :visible.sync="dialogVisible" :width="isMobileShow ? '80%' : '60%'"
    :before-close="handleClose">
    <el-form label-position="left" class="conyentStyles">
      <el-row :gutter="20">
        <el-col :span="isMobileShow ? 24 : 12">
          <el-form-item label="教师姓名：">
            <span> {{ formState.teacherName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="isMobileShow ? 24 : 12">
          <el-form-item label="教师职级：">
            <span>{{ formState.teacherJob }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="isMobileShow ? 24 : 12">
          <el-form-item label="应发工资：">
            <el-input class="is_mobile" v-if="editOrview" v-model="formState.total" disabled></el-input>
            <span v-else>{{ formState.total }}</span>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="isMobileShow ? 24 : 8">
                <el-form-item label="应发工资：">
                    <el-input class="is_mobile" v-if="editOrview" v-model="formState.wageShouldPaid" disabled></el-input>
                    <span v-else>{{formState.wageShouldPaid}}</span>
                </el-form-item>
            </el-col> -->
        <el-col :span="isMobileShow ? 24 : 12">
          <el-form-item label="实际发放：">
            <el-input class="is_mobile" v-if="editOrview" v-model="formState.actualPayroll" disabled></el-input>
            <span v-else>{{ formState.actualPayroll }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-form-item label="底薪：">
        <span>{{ formState.basicSalary }}</span>
      </el-form-item>
      <el-form-item label="义务课时费：">
        <span>{{ formState.dutyClassFee }}</span>
      </el-form-item>
      <el-form-item label="本月课时数：">
        <span>{{ formState.monthClassNum }}</span>
      </el-form-item>
      <el-form-item label="本月课时费：">
        <span>{{ formState.monthClassFee }}</span>
      </el-form-item>
      <!-- <el-form-item label="本月日超五节课天数：">
        <span>{{ formState.exceFiveClassNum }}</span>
      </el-form-item>
      <el-form-item label="本月日超五节课奖金：">
        <span>{{ formState.exceFiveClassFee }}</span>
      </el-form-item>
      <el-form-item label="超额完成课时数：">
        <span>{{ formState.exceClassNum }}</span>
      </el-form-item>
      <el-form-item label="超额完成课时费：">
        <span>{{ formState.extraCalssFee }}</span>
      </el-form-item>
      <el-form-item label="一对多奖励:">
        <span>{{ formState.oneManyFee }}</span>
        <el-popover :placement="isMobileShow ? 'top' : 'right'" :width="isMobileShow ? '80%' : '400'" trigger="click"
          popper-class="popover_content">
          <span>一对多奖励:</span>
          <el-table :data="formState.oneManyDetailList">
            <el-table-column property="nameType" label="授课类型"></el-table-column>
            <el-table-column property="gradeName" label="年级"></el-table-column>
            <el-table-column property="num" label="数量"></el-table-column>
            <el-table-column property="award" label="奖励"></el-table-column>
          </el-table>
          <el-button slot="reference" class="details_btn">详情</el-button>
        </el-popover>
      </el-form-item>
      <el-form-item label="超额完成奖励和一对多奖励：" class="subsidy_hour">
        <span>{{ formState.extraCalssFeeAndOneManyFee }}</span>
      </el-form-item>
      <el-form-item label="当月学生课时数奖励：">
        <span>{{ formState.monthStudentClassAward }}</span>
        <el-popover :placement="isMobileShow ? 'top' : 'right'" :width="isMobileShow ? '80%' : '400'" trigger="click"
          popper-class="popover_content">
          <el-table :data="formState.salaryStudentList">
            <el-table-column property="studentName" label="姓名"></el-table-column>
            <el-table-column property="classNum" label="课节数"></el-table-column>
            <el-table-column property="award" label="奖励"></el-table-column>
          </el-table>
          <el-button slot="reference" class="details_btn">详情</el-button>
        </el-popover>
      </el-form-item>
      <el-divider></el-divider>
    </el-form>
    <el-form class="conyentStyles" label-width="100px" label-position="left">
      <el-form-item label="社保补贴：">
        <el-input v-if="editOrview" v-model="formState.socialSecuritySubsidy"
          @focus="focusBtn(formState.socialSecuritySubsidy, 'minus')" @input="salaryAddBtn"></el-input>
        <span v-else>{{ formState.socialSecuritySubsidy }}</span>
      </el-form-item>
      <el-form-item label="公积金补贴：">
        <el-input v-if="editOrview" v-model="formState.providentFundSubsidy"
          @focus="focusBtn(formState.providentFundSubsidy, 'minus')" @input="salaryAddBtn"></el-input>
        <span v-else>{{ formState.providentFundSubsidy }}</span>
      </el-form-item>
      <el-form-item label="个人社保：">
        <el-input v-if="editOrview" v-model="formState.personalSocialSecurity"
          @focus="focusBtn(formState.personalSocialSecurity)" @input="salaryMinusBtn"></el-input>
        <span v-else>{{ formState.personalSocialSecurity }}</span>
      </el-form-item>
      <el-form-item label="个人公积金：">
        <el-input v-if="editOrview" v-model="formState.individualReserveFund"
          @focus="focusBtn(formState.individualReserveFund)" @input="salaryMinusBtn"></el-input>
        <span v-else>{{ formState.individualReserveFund }}</span>
      </el-form-item>
      <el-form-item label="个税：">
        <el-input v-if="editOrview" v-model="formState.individualIncomeTax"
          @focus="focusBtn(formState.individualIncomeTax)" @input="salaryMinusBtn"></el-input>
        <span v-else>{{ formState.individualIncomeTax }}</span>
      </el-form-item>
      <el-form-item label="已发：">
        <el-input v-if="editOrview" v-model="formState.paidWage"></el-input>
        <span v-else>{{ formState.paidWage }}</span>
      </el-form-item>
      <el-form-item label="代发：">
        <el-input v-if="editOrview" v-model="formState.payrollCredit"></el-input>
        <span v-else>{{ formState.payrollCredit }}</span>
      </el-form-item>
      <el-form-item label="食宿费：">
        <el-input v-if="editOrview" v-model="formState.boardLodgingExpenses"></el-input>
        <span v-else>{{ formState.boardLodgingExpenses }}</span>
      </el-form-item>
      <el-form-item label="伙食费：">
        <el-input v-if="editOrview" v-model="formState.boarder"></el-input>
        <span v-else>{{ formState.boarder }}</span>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose"><span v-if="editOrview">取 消</span><span v-else>关 闭</span></el-button>
      <el-button v-if="editOrview" type="primary" @click="confirmButton">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import apiBaseUrl from "../../../../config/api";
import axios from "axios";
import { getDetailSalary, getUpdateSalary } from "@/api/salaryapi"
import { isMobile } from "@/utils/util"
export default {
  name: "salaryEdit",
  props: {
    childTeacherId: {
      type: Number,
      default: ''
    },
    editOrview: {
      type: Boolean,
      default: ''
    },
  },
  data () {
    return {
      dialogVisible: true,
      formState: {
        teacherName: "", // 教师姓名
        teacherJob: "",// 教师职级
        total: 0,     // 薪酬总额
        wageShouldPaid: "",//应发工资
        actualPayroll: "", //实发工资
        basicSalary: "", // 底薪
        dutyClassFee: "",//义务课时费
        monthClassNum: "",//本月课时数
        monthClassFee: "", // 本月课时费
        exceFiveClassNum: "",// 本月日超5节课天数
        exceFiveClassFee: "", // 本月日超5节课费
        exceClassNum: "",  // 超额完成课时数
        extraCalssFee: "", // 超额完成费时奖金
        monthStudentClassAward: '',// 当月学生课时数奖励
        socialSecuritySubsidy: "",// 社保补贴
        providentFundSubsidy: "",// 公积金补贴
        personalSocialSecurity: "",// 个人社保
        individualReserveFund: "", // 个人公积金
        individualIncomeTax: "", // 个税
        paidWage: "",  // 已发
        payrollCredit: "",  // 代发
        boardLodgingExpenses: "",// 食宿费
      },
      gridData: [],
      Payable: "",  // 应发数额备份
      actualOccurrence: "", // 实际发放
      isMobileShow: true, // 判断手机端还是手机端
    }
  },
  created () {
    if (isMobile) {
      this.isMobileShow = true
    } else {
      this.isMobileShow = false
    }
    this.getInfo()
  },
  computed: {
  },
  methods: {
    getInfo () {
      getDetailSalary({ id: this.childTeacherId }).then((res) => {
        if (res.data) {
          this.formState = res.data
          if (this.formState.oneManyDetailList) {
            for (let i = 0; i < this.formState.oneManyDetailList.length; i++) {
              this.formState.oneManyDetailList[i].nameType = this.formState.oneManyDetailList[i].classType == 1 ? '1v1' : this.formState.oneManyDetailList[i].classType == 2 ? "1v2" : this.formState.oneManyDetailList[i].classType == 3 ? "1v3" : ''
            }
          }
        }
      })
    },
    focusBtn (val, row) {
      if (row == "minus") {
        this.Payable = Number(this.formState.total) - Number(val)
        this.actualOccurrence = Number(this.formState.actualPayroll) - Number(val)
      } else {
        // this.Payable = Number(this.formState.total) + Number(val)
        this.actualOccurrence = Number(this.formState.actualPayroll) + Number(val)
      }
    },
    // 社保补贴：
    salaryAddBtn (val, row) {
      this.formState.total = Number(this.Payable) + Number(val)
      this.formState.actualPayroll = Number(this.actualOccurrence) + Number(val)
    },
    salaryMinusBtn (val) { // 个税 社保 公积金
      // this.formState.total = Number(this.Payable) - Number(val)
      this.formState.actualPayroll = Number(this.actualOccurrence) - Number(val)
    },
    handleClose () {
      this.$emit('isShowBtn', false)
    },
    confirmButton () {
      getUpdateSalary(this.formState).then((res) => {
        console.log(res);
        if (res.code == '200') {
          this.$message.success("编辑成功")
        } else {
          this.$message.error("编辑失败")
        }
      })
      this.handleClose()
    },
  }
}
</script>

<style scoped lang="less">
.el-input {
  width: 70%;
}

/deep/.conyentStyles {
  .el-form-item {
    text-align: left;
  }
}

.details_btn {
  height: 25px;
  line-height: 25px;
  position: absolute;
  right: 20px;
  top: 8px;
  display: inline-block;
  padding: 0px 8px;
  background-color: #efefef;
  border: 1px solid gray;
  cursor: pointer;
}

.popover_title {
  display: inline-block;
  width: 49%;
}

.line_divider {
  background: #DCDFE6;
  height: 1px;
  margin: 8px 0;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  .el-dialog {
    width: 83%;
    overflow-x: auto;
  }
}

.is_mobile {
  width: 50%;
}</style>


// WEBPACK FOOTER //
// src/manager/salary/components/salaryEdit.vue